import React, { useEffect } from 'react'
import { IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import UnassignedAssetListTable from './UnassignedAssetDetails'
import { type RootState } from '../../../../store'
import { useSelector } from 'react-redux'
import LanguageStrings from '../../../../i18n/locales'
import { type CheckboxDropdownMode } from '../../../../components/CheckboxDropdown'
import { type ConjuctionOptions } from '../../types'
import { type AdvFilterParameterConditions } from './AssignedAssetList'

const UnAssignAssetWindowStrings = LanguageStrings().AssetGroupStrings.GroupDetailsComponent.UnAssignAssetWindow

interface ParentProps {
  assetTypeId: string
  onClose: () => void
  addedAssets: string[]
  setAddedAssets: React.Dispatch<React.SetStateAction<string[]>>
  setShowAddAssetWindow: React.Dispatch<React.SetStateAction<boolean>>
  unselectedAssets: string[]
  setUnselectedAssets: React.Dispatch<React.SetStateAction<string[]>>
  searchInput: string
  setSearchInput: React.Dispatch<React.SetStateAction<string>>
  selectedOption: CheckboxDropdownMode
  setSelectedOption: React.Dispatch<React.SetStateAction<CheckboxDropdownMode>>
  selectedPages: number[]
  setSelectedPages: React.Dispatch<React.SetStateAction<number[]>>
  pagesWithIndividualSelections: number[]
  setPagesWithIndividualSelections: React.Dispatch<React.SetStateAction<number[]>>
  fullyUnselectedPages: number[]
  setFullyUnselectedPages: React.Dispatch<React.SetStateAction<number[]>>
  conditions: AdvFilterParameterConditions[]
  setConditions: React.Dispatch<React.SetStateAction<AdvFilterParameterConditions[]>>
  conjuction: ConjuctionOptions
  setConjunction: React.Dispatch<React.SetStateAction<ConjuctionOptions>>
  setIsAdvanceFilterSelected: React.Dispatch<React.SetStateAction<boolean>>
}

const UnassignAssetWindow = (props: ParentProps): JSX.Element => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])
  const numUnassignedAssets = useSelector((state: RootState) => state.UnassignedAssetList.unassignedAssetList !== null ? state.UnassignedAssetList.unassignedAssetList.total_count : 0)
  return (
    <div style={{ backgroundColor: 'rgb(0,0,0,0.4)', height: '100vh', width: '100vw', position: 'fixed', zIndex: 1000, top: 0, backdropFilter: 'blur(5px)', left: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div id='modal-div-add-asset' style={{ width: '90vw', backgroundColor: '#272727', maxHeight: '90vh' }}>
        <div className='configurations-table-heading' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.5em' }}>
          <span style={{ fontSize: 24, fontWeight: 500 }}>{UnAssignAssetWindowStrings.AssignAsset}<span className='config-list-box' style={{ fontSize: '16px' }}>{numUnassignedAssets} {UnAssignAssetWindowStrings.Assets}</span></span>
          <IconButton data-testid={'close-cross-btn'} onClick={props.onClose}>
            <CloseIcon />
        </IconButton>
        </div>
        <UnassignedAssetListTable
          fullyUnselectedPages={props.fullyUnselectedPages} setFullyUnselectedPages={props.setFullyUnselectedPages}
          pagesWithIndividualSelections={props.pagesWithIndividualSelections} setPagesWithIndividualSelections={props.setPagesWithIndividualSelections}
          selectedPages={props.selectedPages} setSelectedPages={props.setSelectedPages}
          unselectedAssets={props.unselectedAssets} setUnselectedAssets={props.setUnselectedAssets}
          searchInput={props.searchInput} setSearchInput={props.setSearchInput} selectedOption={props.selectedOption} setSelectedOption={props.setSelectedOption}
          setShowAddAssetWindow={props.setShowAddAssetWindow} addedAssets={props.addedAssets} setAddedAssets={props.setAddedAssets} assetTypeId={props.assetTypeId} conditions={props.conditions} setConditions={props.setConditions} conjuction={props.conjuction} setConjunction={props.setConjunction} setIsAdvanceFilterSelected={props.setIsAdvanceFilterSelected} />
      </div>
    </div>
  )
}

export default UnassignAssetWindow
